import { useBestClientsQuery } from "../utils/queries.js";
import {
  ChartCard,
  ChartNoDataFound,
  formatNumber,
  placeholder,
  useEffect,
  useState,
} from "@";

const BestClients = () => {
  const [data, setData] = useState([]);
  const [searchDuration, setSearchDuration] = useState(3);

  // Use React Query to fetch best clients data
  const { data: bestClientsData } = useBestClientsQuery(searchDuration);

  // Fetch data based on the duration
  const fetchData = (value) => {
    setSearchDuration(value);
  };

  useEffect(() => {
    if (bestClientsData?.bestUsers) {
      setData(bestClientsData.bestUsers);
    }
  }, [bestClientsData]);
  return (
    <>
      <ChartCard
        title="افضل العملاء"
        searchDurationUpdated={fetchData}
        searchDuration={searchDuration}
      >
        {data?.length > 0 ? (
          <div className="relative mt-3 overflow-x-auto">
            <table className="w-full text-sm text-gray-500 dark:text-gray-400">
              <thead className="border-b border-gray-100 text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-3 py-3"></th>
                  <th scope="col" className="px-1 py-3 text-center">
                    رقم الجوال
                  </th>
                  <th scope="col" className="px-1 py-3 text-center">
                    عدد الطلبات
                  </th>
                  <th scope="col" className="px-1 py-3 text-center">
                    المبيعات
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((user, i) => (
                  <tr key={i} className="text-gray-500 dark:text-gray-400">
                    <th className="px-3 py-1.5">
                      <div className="flex items-center justify-start">
                        <img
                          alt={user.displayName}
                          src={placeholder}
                          className="h-12 w-12 rounded-full object-cover"
                        />
                        <h3 className="ms-2 text-sm dark:text-gray-400">
                          {user.displayName}
                        </h3>
                      </div>
                    </th>

                    <th className="px-1 py-1.5 text-center">
                      {user.phoneNumber}
                    </th>
                    <th className="px-1 py-1.5 text-center">
                      {formatNumber(user.ordersCount)}
                    </th>
                    <th className="px-1 py-1.5 text-center">
                      {formatNumber(user.ordersAmount)} ر.س
                    </th>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="h-80">
            <ChartNoDataFound />
          </div>
        )}
      </ChartCard>
    </>
  );
};

export default BestClients;
